'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../node_modules/tslib/tslib.es6.js');
var cms = require('../../../decorators/cms.js');
var enums = require('../../cms/enums.js');
var classes = require('../../cms/classes.js');
var baseSections = require('../enums/baseSections.js');
var base = require('../fields/base.js');

exports.PanelFields = class PanelFields extends classes.BaseComponentCMSFields {
    constructor() {
        super();
    }
};
tslib_es6.__decorate([
    cms.CMSField('Layout', enums.CMSFieldTypes.RadioSelect, {
        selectOptions: [
            { label: 'Image On Left', value: baseSections.PanelFieldsLayouts.ImageOnLeft },
            { label: 'Image On Right', value: baseSections.PanelFieldsLayouts.ImageOnRight }
        ]
    }),
    tslib_es6.__metadata("design:type", String)
], exports.PanelFields.prototype, "layout", void 0);
tslib_es6.__decorate([
    cms.CMSField('Image', enums.CMSFieldTypes.Image),
    tslib_es6.__metadata("design:type", String)
], exports.PanelFields.prototype, "imageUrl", void 0);
tslib_es6.__decorate([
    cms.CMSField('Heading Text', enums.CMSFieldTypes.Text),
    tslib_es6.__metadata("design:type", String)
], exports.PanelFields.prototype, "headingText", void 0);
tslib_es6.__decorate([
    cms.CMSField('Body Text', enums.CMSFieldTypes.TextArea),
    tslib_es6.__metadata("design:type", String)
], exports.PanelFields.prototype, "bodyText", void 0);
tslib_es6.__decorate([
    cms.CMSField('CTA Link', enums.CMSFieldTypes.ToggleWithNestedOptions, {
        childFieldsType: base.CtaLinkToggle
    }),
    tslib_es6.__metadata("design:type", base.CtaLinkToggle)
], exports.PanelFields.prototype, "ctaLink", void 0);
exports.PanelFields = tslib_es6.__decorate([
    cms.CMSObject('sections.base.Panel', 'Panel'),
    tslib_es6.__metadata("design:paramtypes", [])
], exports.PanelFields);
exports.LocationsFields = class LocationsFields extends classes.BaseComponentCMSFields {
    constructor() {
        super();
    }
};
tslib_es6.__decorate([
    cms.CMSField('Heading Text', enums.CMSFieldTypes.Text),
    tslib_es6.__metadata("design:type", String)
], exports.LocationsFields.prototype, "headingText", void 0);
tslib_es6.__decorate([
    cms.CMSField('Show Title', enums.CMSFieldTypes.Toggle),
    tslib_es6.__metadata("design:type", Boolean)
], exports.LocationsFields.prototype, "showHeading", void 0);
tslib_es6.__decorate([
    cms.CMSField('Show Address', enums.CMSFieldTypes.Toggle),
    tslib_es6.__metadata("design:type", Boolean)
], exports.LocationsFields.prototype, "showAddress", void 0);
tslib_es6.__decorate([
    cms.CMSField('Show Details CTA', enums.CMSFieldTypes.Toggle),
    tslib_es6.__metadata("design:type", Boolean)
], exports.LocationsFields.prototype, "showDetailsCTA", void 0);
tslib_es6.__decorate([
    cms.CMSField('Show Order Online CTA', enums.CMSFieldTypes.Toggle),
    tslib_es6.__metadata("design:type", Boolean)
], exports.LocationsFields.prototype, "showOrderOnlineCTA", void 0);
exports.LocationsFields = tslib_es6.__decorate([
    cms.CMSObject('sections.base.Locations', 'Locations', {
        isBeta: true,
        dataRequirements: [enums.DataRequirementTypes.WebsiteLocation]
    }),
    tslib_es6.__metadata("design:paramtypes", [])
], exports.LocationsFields);
exports.MenusFields = class MenusFields extends classes.BaseComponentCMSFields {
    constructor() {
        super();
    }
};
tslib_es6.__decorate([
    cms.CMSField('Heading Text', enums.CMSFieldTypes.Text),
    tslib_es6.__metadata("design:type", String)
], exports.MenusFields.prototype, "headingText", void 0);
tslib_es6.__decorate([
    cms.CMSField('Show Title', enums.CMSFieldTypes.Toggle),
    tslib_es6.__metadata("design:type", Boolean)
], exports.MenusFields.prototype, "showHeading", void 0);
exports.MenusFields = tslib_es6.__decorate([
    cms.CMSObject('sections.base.Menus', 'Menus', {
        isBeta: true,
        dataRequirements: [enums.DataRequirementTypes.Menu]
    }),
    tslib_es6.__metadata("design:paramtypes", [])
], exports.MenusFields);
//# sourceMappingURL=base.js.map
